import { Button, message } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import ModalComponent from "../../components/formComponent/ModalComponent";
import FormTextField from "../../components/general/FormTextField";
import FormContainer from "../../components/general/FormContainer";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import { postRequest } from "../../services/mainApp.service";

const AuthLoginModal = (props) => {
    const { featureName, visible, setVisible, onSuccess, menuName } = props;
    const userData = useSelector((state) => state.authReducer);
    const controller = new window.AbortController();
    const [loginData, setLoginData] = useState({
        Username: "",
        Password: "",
        BranchId: userData.BranchId,
        FeatureName: "",
        MenuName: "",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            Username: loginData.Username,
            Password: loginData.Password,
            BranchId: userData.branchId,
            FeatureName: featureName,
            MenuName: menuName || "",
        };


        postRequest("UserFeatureAuth", data)
            .then((response) => {

                if (response.data && response.data.Data.IsAuthorized) {
                    setVisible(false);
                    onSuccess && onSuccess();
                } else {
                    message.error("Unauthorized User!");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const loginChange = (event) => {
        setLoginData({ ...loginData, [event.name]: event.value });
    };

    return (
        <ModalComponent
            title="Authenticate"
            isModalVisible={visible}
            footer={null}
            vh
            width="40vw"
        >
            <FormContainer onSubmit={handleSubmit}>
                <FormTextField
                    value={loginData.Username}
                    colSpan={12}
                    label="Username"
                    size={INPUT_SIZE}
                    name="Username"
                    onChange={loginChange}
                    required={true}
                />
                <FormTextField
                    value={loginData.Password}
                    colSpan={12}
                    label="Password"
                    size={INPUT_SIZE}
                    name="Password"
                    onChange={loginChange}
                    type="password"
                    required={true}
                />
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        borderTop: "1px solid #eee",
                        paddingTop: "15px",
                        marginTop: "24px",
                        gap: "10px",
                    }}
                >
                    <Button
                        onClick={() => {
                            setVisible(false);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit">
                        Login
                    </Button>
                </div>
            </FormContainer>
        </ModalComponent>
    );
};

export default AuthLoginModal;
